import { connect } from 'react-redux'
import ChatView from './view.jsx';
import _ from 'lodash';

import { sendMessage, fetchMessages, invalidateSmallTalkSession, toggleSmallTalkWindowVisibility } from 'src/legacy/redux/actions/smallTalk.jsx';
import { associateChatUser, updateUnreadForChatUser, fetchCurrentlyViewingAsset, sendMessageAsEmail  } from 'src/legacy/redux/actions/chatUsers.jsx';
import { fetchAsset } from 'src/legacy/redux/actions/assets.jsx';
import { fetchContact } from 'src/legacy/redux/actions/rolodex.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import { trackAdoptionMetricsForMessageSentEvent } from 'src/legacy/redux/actions/adoption.jsx';

const mapStateToProps = (state, ownProps) => {

  return {
    chatUser: state.legacyRootReducer.chatUser.item,
    user: state.users.me,
    account: state.accounts.item,
    uuid: `u_${state.users.me.id}`,
    messages: _.get(state.legacyRootReducer, 'smallTalk.session.messages.items') || [],
    userAssociations: _.get(state.legacyRootReducer, 'chatUser.item.userAssociations') || [],
    contact: _.get(state.legacyRootReducer, 'rolodex.contact.item'),//check
    assetId: _.get(state.legacyRootReducer, 'chatUser.item.liveView.assetId'),
    asset: _.get(state.legacyRootReducer, 'asset.item'),
    liveViewUpdated: _.get(state.legacyRootReducer, 'chatUser.item.liveView.updated')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendMessage: (client, message) => {
      return dispatch(sendMessage(client, message))
    },

    invalidateSmallTalkSession: (contact) => {
      return dispatch(invalidateSmallTalkSession(contact));
    },

    fetchMessages: (client, channels, limit) => {
      return dispatch(fetchMessages(client, channels, limit));
    },

    toggleSmallTalkWindowVisibility: (contact) => {
      return dispatch(toggleSmallTalkWindowVisibility(contact));
    },

    associateChatUser: (chatUserId, uuid) => {
      return dispatch(associateChatUser(chatUserId, uuid));
    },

    fetchContact: (id) => {
      return dispatch(fetchContact(id));
    },

    updateUnreadForChatUser: (uuid) => {
      return dispatch(updateUnreadForChatUser(uuid));
    },

    fetchCurrentlyViewingAsset: (chatUserId) => {
      return dispatch(fetchCurrentlyViewingAsset(chatUserId));
    },

    fetchAsset: (id) => {
      return dispatch(fetchAsset(id));
    },

    sendMessageAsEmail: (chatUserId, message) => {
      return dispatch(sendMessageAsEmail(chatUserId, message));
    },

    trackAdoptionMetricsForMessageSentEvent: () => {
      return dispatch(trackAdoptionMetricsForMessageSentEvent());
    }
  }
}

const ChatContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatView)

export default withUseHooks(ChatContainer);